import { render, staticRenderFns } from "./userTemplate.vue?vue&type=template&id=370ac15e"
import script from "./userTemplate.vue?vue&type=script&lang=js"
export * from "./userTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports